import apiClient from './apiClient';

// ============================================================
// Types
// ============================================================

export interface CalcParams {
  year: number;
  month: number;
  attendStartYear: number;
  attendStartMonth: number;
  attendEndYear: number;
  attendEndMonth: number;
  empFrom: string;
  empTo: string;
}

export interface SalaryItem {
  itemCode: string;
  itemName: string;
  itemType: string; // "A"=addition, "D"=deduction
  amount: number;
}

export interface EmployeeSalary {
  empCode: string;
  empName: string;
  deptCode: string;
  grossPay: number;
  deductions: number;
  netPay: number;
  items: SalaryItem[];
}

export interface CalcResult {
  processed: number;
  results: EmployeeSalary[];
}

export interface CalcStatus {
  lastYear: number;
  lastMonth: number;
  lastProcessed: number;
  lastRunAt: string;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API Methods
// ============================================================

export const pw9531Api = {
  async execute(params: CalcParams): Promise<CalcResult> {
    const res = await apiClient.post('/api/pw9531/execute', params);
    return res.data;
  },

  async preview(params: CalcParams): Promise<CalcResult> {
    const res = await apiClient.post('/api/pw9531/preview', params);
    return res.data;
  },

  async getStatus(): Promise<CalcStatus> {
    const res = await apiClient.get('/api/pw9531/status');
    return res.data;
  },
};

export default pw9531Api;
